/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionFlowFieldDto
 */
export interface SubscriptionFlowFieldDto {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionFlowFieldDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionFlowFieldDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionFlowFieldDto
     */
    type: SubscriptionFlowFieldDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionFlowFieldDto
     */
    readOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionFlowFieldDto
     */
    optional?: boolean;
}


/**
 * @export
 */
export const SubscriptionFlowFieldDtoTypeEnum = {
    Text: 'text',
    Email: 'email',
    PhoneNumber: 'phone-number'
} as const;
export type SubscriptionFlowFieldDtoTypeEnum = typeof SubscriptionFlowFieldDtoTypeEnum[keyof typeof SubscriptionFlowFieldDtoTypeEnum];


/**
 * Check if a given object implements the SubscriptionFlowFieldDto interface.
 */
export function instanceOfSubscriptionFlowFieldDto(value: object): value is SubscriptionFlowFieldDto {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function SubscriptionFlowFieldDtoFromJSON(json: any): SubscriptionFlowFieldDto {
    return SubscriptionFlowFieldDtoFromJSONTyped(json, false);
}

export function SubscriptionFlowFieldDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionFlowFieldDto {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'name': json['name'],
        'type': json['type'],
        'readOnly': json['readOnly'] == null ? undefined : json['readOnly'],
        'optional': json['optional'] == null ? undefined : json['optional'],
    };
}

export function SubscriptionFlowFieldDtoToJSON(json: any): SubscriptionFlowFieldDto {
    return SubscriptionFlowFieldDtoToJSONTyped(json, false);
}

export function SubscriptionFlowFieldDtoToJSONTyped(value?: SubscriptionFlowFieldDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'name': value['name'],
        'type': value['type'],
        'readOnly': value['readOnly'],
        'optional': value['optional'],
    };
}

